import React from 'react';
import PageWrapper from '../components/ui/PageWrapper';
import FadeUp from '../components/ui/FadeUp';

const posts = [
  {
    category: 'Home Vastu', title: 'The 8 Directions of Vastu Shastra Explained',
    excerpt: 'Understand how each of the 8 directions in Vastu Shastra governs different aspects of life — from health to wealth to relationships.',
    date: 'Dec 15, 2024', readTime: '5 min read'
  },
  {
    category: 'Remedies', title: 'Top 10 Vastu Remedies Without Demolition',
    excerpt: 'Discover powerful Vastu corrections you can implement today without breaking a single wall. Simple, effective and scientifically grounded.',
    date: 'Dec 10, 2024', readTime: '7 min read'
  },
  {
    category: 'Commercial', title: 'Vastu for Your Office: Boost Business by 40%',
    excerpt: 'Learn how proper office Vastu — from the entrance to the MD\'s cabin — can dramatically improve business performance and team productivity.',
    date: 'Dec 5, 2024', readTime: '6 min read'
  },
  {
    category: 'Kitchen Vastu', title: 'Kitchen Vastu: The Heart of Your Home',
    excerpt: 'The kitchen represents the fire element in Vastu. Discover how its placement and design affect the health and prosperity of your family.',
    date: 'Nov 28, 2024', readTime: '4 min read'
  },
  {
    category: 'Bedroom', title: 'Master Bedroom Vastu for Harmony & Health',
    excerpt: 'Your bedroom is your sanctuary. Learn the Vastu principles for optimal sleep direction, bed placement and colour choices.',
    date: 'Nov 20, 2024', readTime: '5 min read'
  },
  {
    category: 'Science', title: 'The Science Behind Vastu Shastra',
    excerpt: 'Dr. Ahirrao explains the scientific basis of Vastu — from geomagnetic fields to solar energy and how they influence human wellbeing.',
    date: 'Nov 12, 2024', readTime: '8 min read'
  },
];

const categories = ['All', 'Home Vastu', 'Commercial', 'Remedies', 'Kitchen Vastu', 'Bedroom', 'Science'];

export default function Blog() {
  const [active, setActive] = React.useState('All');
  const filtered = active === 'All' ? posts : posts.filter(p => p.category === active);

  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 50% 50%, rgba(232,135,26,0.05) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">Knowledge Hub</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}>Vastu Blog</h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 520, lineHeight: 1.8 }}>
              Insights, tips and wisdom from Raghav Taparia on Vastu Shastra, energy healing and harmonious living.
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          {/* Category filter */}
          <FadeUp style={{ marginBottom: 48 }}>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {categories.map(cat => (
                <button key={cat} onClick={() => setActive(cat)} style={{
                  padding: '8px 18px', borderRadius: 20, border: '1px solid',
                  borderColor: active === cat ? '#E8871A' : 'rgba(232,135,26,0.2)',
                  background: active === cat ? 'rgba(232,135,26,0.1)' : 'transparent',
                  color: active === cat ? '#E8871A' : '#FDF6EC',
                  fontSize: 13, cursor: 'pointer', transition: 'all 0.2s',
                  fontFamily: 'Inter, sans-serif', opacity: active === cat ? 1 : 0.6
                }}>
                  {cat}
                </button>
              ))}
            </div>
          </FadeUp>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 28 }}>
            {filtered.map((post, i) => (
              <FadeUp key={i} delay={i * 0.08}>
                <div style={{
                  background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.1)',
                  borderRadius: 14, overflow: 'hidden', cursor: 'pointer',
                  transition: 'border-color 0.3s'
                }}
                  onMouseEnter={e => (e.currentTarget.style.borderColor = 'rgba(232,135,26,0.3)')}
                  onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(232,135,26,0.1)')}
                >
                  {/* Placeholder image */}
                  <div style={{
                    height: 180, background: 'linear-gradient(135deg, rgba(232,135,26,0.1), rgba(201,84,122,0.05))',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    <svg width="60" height="60" viewBox="0 0 60 60" opacity={0.3}>
                      <circle cx="30" cy="30" r="28" stroke="#E8871A" strokeWidth="1" fill="none" />
                      <polygon points="30,5 52,45 8,45" stroke="#E8871A" strokeWidth="1" fill="none" />
                      <polygon points="30,55 8,15 52,15" stroke="#C9547A" strokeWidth="1" fill="none" />
                    </svg>
                  </div>
                  <div style={{ padding: '24px 24px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                      <span style={{ fontSize: 11, color: '#E8871A', letterSpacing: 1, fontWeight: 600 }}>
                        {post.category.toUpperCase()}
                      </span>
                      <span style={{ fontSize: 11, opacity: 0.4 }}>{post.readTime}</span>
                    </div>
                    <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 10, lineHeight: 1.4 }}>
                      {post.title}
                    </h2>
                    <p style={{ fontSize: 13, opacity: 0.65, lineHeight: 1.7, marginBottom: 16 }}>{post.excerpt}</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 12, opacity: 0.4 }}>{post.date}</span>
                      <span style={{ fontSize: 13, color: '#E8871A' }}>Read more →</span>
                    </div>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}
